import * as React from 'react';

import SideNav from 'af-components/SideNav/SideNav';

export default () => <SideNav />;
